<template>
  <div></div>
</template>

<script>
 import { mapState, mapGetters } from 'vuex'
 import customThemes from '@/plugins/themes.js'

 const ZENDESK_URL = 'https://static.zdassets.com/ekr/snippet.js?key=10d71cee-12cc-4765-aeb3-e8817058d081';

 export default {
   name: 'SupportChat',
   components: {
   },

   data() {
     return {
       zendesk_script_id: 'ze-snippet',
     };
   },

   computed: {
     ...mapGetters(['sitePath', 'user']),
     ...mapState(['currentTheme']),

     allow_chat() {
       return this.user && this.user.support_level && this.user.support_level.chat;
     },
   },

   mounted() {
     this.check();
   },

   methods: {
     zendesk_settings() {
       let self = this;
       return {
         webWidget: {
           analytics: false, // Disable Google Analytics
           color: {
             get theme() {
               return self.get_theme_color();
             },
           },
           position: {
             horizontal: 'left',
             vertical: 'bottom',
           },
           offset: {
             horizontal: '0px',
             vertical: '-10px',
           },
         },
       };
     },

     check() {
       if (this.allow_chat)
         this.show();
       else
         this.hide();
     },

     install_zendesk() {
       if (!document.getElementById(this.zendesk_script_id)) {
         // Zendesk customitzation and onLoad HACK
         let self = this;
         window._chat_install_event = false;
         window.zESettings = {
           get webWidget() {
             if (!window._chat_install_event) {
               window._chat_install_event = true;
               setTimeout(self.on_chat_install.bind(self), 1); // old-school async ;-p
             }
             return self.zendesk_settings().webWidget;
           },
         };

         // Inject zendesk javascript code
         let script = document.createElement("script");
         script.type = "text/javascript";
         script.src = ZENDESK_URL;
         script.id = this.zendesk_script_id;
         document.body.appendChild(script);
       }

       // Show chat button
       let chatbutton = document.querySelector('iframe#launcher')
       if (chatbutton)
         chatbutton.style.display = 'block';
     },

     show() {
       this.install_zendesk();
     },

     hide() {
       let chatbutton = document.querySelector('iframe#launcher')
       if (chatbutton)
         chatbutton.style.display = 'none';
     },

     get_user_fullname(user) {
       // safeguards if either or both first and last name aren't set
       if (user.first_name && user.last_name)
         return user.last_name + ", " + user.first_name
       if (user.first_name) return user.first_name
       if (user.last_name) return user.last_name
       return user.email
     },

     set_chat_user() {
       if (window.zE) {
         window.zE('webWidget', 'prefill', {
           name: {
             value: this.get_user_fullname(this.user),
             readOnly: true,
           },
           email: {
             value: this.user.email,
             readOnly: true,
           },
           phone: {
             value: this.sitePath,
             readOnly: true,
           },
         });
       }
     },

     refresh_zendesk_settings() {
       if (!window.zE)
         return;
       window.zE('webWidget', 'updateSettings', this.zendesk_settings());
       this.set_chat_user();
     },
     
     get_theme_color() {
       return ((customThemes[this.currentTheme]||{}).light||{}).primary;
     },

     on_chat_install() {
       this.set_chat_user();
       if (window.zE) {
         zE('webWidget', 'setLocale', 'es');
       }
     },
   },

   watch: {
     user(us) {
       this.check();
       this.set_chat_user();
     },
   }
 }
</script>

<style lang="scss">
</style>
